module.exports = __webpack_public_path__ + "static/media/padlock.5f0a8f86.png";